import React, {Component} from "react";
import "./Skill.css";

import Icon from "Icon/Icon";

export default class Skill extends Component
{
	render()
	{
		return (
			<div className="skill">
				<div className="icon" style={{backgroundColor: this.props.color}}>
					<Icon>{this.props.icon}</Icon>
				</div>

				<div className="info">
					<div className="title" style={{color: this.props.color}}>
						{this.props.title}
					</div>

					<div className="desc">
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/About/Skills/Skill/Skill.js